// UserDashboard.js
import React, { useState, useEffect } from "react";
import ApiService from '../../services/ApiService';
import { toast } from "react-toastify";

const DashboardPage = () => {
  const user= JSON.parse(localStorage.getItem('user'));
  
  const [tab, setTab] = useState("email");
  const [username, setUsername] = useState(user.username);
  const [phone, setPhone] = useState(user.phone);
  const [address, setAddress] = useState(user.address);
  const [email, setEmail] = useState(user.email);
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [isLoader, setIsLoader] = useState(false);

  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    setIsLoader(true);
    try {
        const formData = {
            "username": username,
            "phone": phone,
            "address": address,
            "email": email,
            "old_password": oldPassword,
            "new_password": newPassword,
            "confirm_password": confirmPassword,
          };

        const response = await ApiService.request({
            method: "POST",
            url: "updateAccount", 
            data:formData
        });
        const data = response.data;
        if (data.status) {
            user.email=email;
            user.username=username;
            user.phone=phone;
            user.address=address;
            localStorage.setItem('user', JSON.stringify(user));
            toast.success(data.message);
        } else {
            toast.error(data.message);
        }
        setIsLoader(false);
    } catch (error) {
        console.log(error);

        setIsLoader(false);
    }
   
};

  return (
    <div>
     
          <div className="dashboard rounded d-flex p-3">
                <div className="card">
                    <nav>
                        <div className="nav nav-tabs" id="nav-tab" role="tablist">
                        <button
                            className={`nav-link border fs-lg-5 ${tab === "email" ? "active" : ""}`}
                            onClick={() => setTab("email")}
                            id="nav-profile-tab"
                            type="button"
                        >
                            <i className="bi bi-envelope"></i> Change Info
                        </button>
                        <button
                            className={`nav-link border fs-lg-5 ${tab === "password" ? "active" : ""}`}
                            onClick={() => setTab("password")}
                            id="nav-contact-tab"
                            type="button"
                        >
                            <i className="bi bi-key"></i> Change Password
                        </button>
                        </div>
                    </nav>
                    <div className="card-body pt-0">
                        <div className="mb-8 text-center"></div>
                        <div className="row g-9 mb-8">
                        <div className="col-md-12">
                            <div className="tab-content mt-5" id="nav-tabContent">
                            {tab === "email" && (
                                <div className="tab-pane fade show active">
                                <form className="form" onSubmit={handleSubmit}>
                                    <div className="row">
                                      <div className="col-md-6 mb-3">
                                        <label className="d-flex align-items-center fs-6 fw-semibold mb-2">
                                              <span className="required">Username</span>
                                          </label>
                                          <input
                                              type="text"
                                              value={username}
                                              onChange={(e) => setUsername(e.target.value)}
                                              className="form-control form-control-solid"
                                              placeholder="Enter Username"
                                          />
                                      </div>
                                      <div className="col-md-6 mb-3">
                                        <label className="d-flex align-items-center fs-6 fw-semibold mb-2">
                                              <span className="required">Phone</span>
                                          </label>
                                          <input
                                              type="phone"
                                              value={phone}
                                              onChange={(e) => setPhone(e.target.value)}
                                              className="form-control form-control-solid"
                                              placeholder="Enter Phone Number"
                                          />
                                      </div>
                                      <div className="col-md-6">
                                          <label className="d-flex align-items-center fs-6 fw-semibold mb-2">
                                              <span className="required">Email</span>
                                          </label>
                                          <input
                                              type="email"
                                              value={email}
                                              onChange={(e) => setEmail(e.target.value)}
                                              className="form-control form-control-solid"
                                              placeholder="Enter Email"
                                          />
                                      </div>
                                      <div className="col-md-6 mb-3">
                                        <label className="d-flex align-items-center fs-6 fw-semibold mb-2">
                                              <span className="required">Address</span>
                                          </label>
                                          <input
                                              type="address"
                                              value={address}
                                              onChange={(e) => setAddress(e.target.value)}
                                              className="form-control form-control-solid"
                                              placeholder="Enter Address"
                                          />
                                      </div>
                                       
                                    </div>
                                   
                                    <button
                                    type="submit"
                                    className="btn btn-base my-5"
                                    disabled={isLoader}
                                    >
                                    <span className="indicator-label">
                                       Update Info {isLoader && <span class="spinner-grow spinner-grow-sm"></span>}
                                    </span>
                                    </button>
                                </form>
                                </div>
                            )}
                            {tab === "password" && (
                                <div className="tab-pane fade show active">
                                <form className="form" onSubmit={handleSubmit}>
                                    <div className="row">
                                    <div className="col-md-12">
                                        <label className="required fs-6 fw-semibold mb-2">
                                        Current Password
                                        </label>
                                        <input
                                        type="password"
                                        className="form-control form-control-solid"
                                        placeholder="Enter Your Old Password"
                                        value={oldPassword}
                                        onChange={(e) => setOldPassword(e.target.value)}
                                        />
                                        <br />
                                    </div>
                                    <div className="col-md-6">
                                        <label className="required fs-6 fw-semibold mb-2">
                                        New Password
                                        </label>
                                        <input
                                        type="password"
                                        className="form-control form-control-solid"
                                        placeholder="Enter New Password"
                                        value={newPassword}
                                        onChange={(e) => setNewPassword(e.target.value)}
                                        />
                                    </div>
                                    <div className="col-md-6">
                                        <label className="required fs-6 fw-semibold mb-2">
                                        Confirm Password
                                        </label>
                                        <input
                                        type="password"
                                        className="form-control form-control-solid"
                                        placeholder="Enter Confirm Password"
                                        value={confirmPassword}
                                        onChange={(e) => setConfirmPassword(e.target.value)}
                                        />
                                    </div>
                                    </div>
                                    <button
                                    type="submit"
                                    className="btn btn-base my-5"
                                    disabled={isLoader}
                                    >
                                    <span className="indicator-label">
                                      Update Password {isLoader && <span class="spinner-grow spinner-grow-sm"></span>}
                                    </span>
                                    </button>
                                </form>
                                </div>
                            )}
                            </div>
                        </div>
                        </div>
                    </div>
                </div>
          
          </div>
        
              
    </div>
  );
};

export default DashboardPage;
